import { css } from '@emotion/react'

export const styles = css({
  background: 'rgb(0, 191, 255)',
  border: '4px solid white',
  borderRadius: '50%',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.24)',
  boxSizing: 'border-box',
  height: '20px',
  opacity: 1,
  position: 'relative',
  width: '20px',
  zIndex: 1,
})
